import * as React from 'react';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { MaterialUIThemeProvider } from "../../helpers/material-ui-theme";
import { getRadioRootStyles, getRadioIconStyles, getRadioLabelStyles } from "./RadioButtons.styles";
var useStyles = makeStyles({
  label: getRadioLabelStyles,
  radioRoot: getRadioRootStyles,
  icon: getRadioIconStyles
});

function RadioButtons(_ref) {
  var label = _ref.label,
      options = _ref.options,
      onChange = _ref.onChange,
      value = _ref.value,
      row = _ref.row,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var classes = useStyles({
    size: size
  });

  var handleChange = function handleChange(event) {
    var selectedOption = options.find(function (option) {
      return option.key === event.target.value;
    });

    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return /*#__PURE__*/React.createElement(MaterialUIThemeProvider, null, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    component: "legend"
  }, label), /*#__PURE__*/React.createElement(RadioGroup, {
    value: value,
    onChange: handleChange,
    row: row
  }, options.map(function (_ref2) {
    var key = _ref2.key,
        value = _ref2.value,
        disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement(Box, {
      py: 0.5,
      key: key,
      "data-test-id": key
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      classes: {
        label: classes.label,
        root: classes.labelRoot
      },
      value: key,
      control: /*#__PURE__*/React.createElement(Radio, {
        className: classes.radioRoot,
        color: "primary",
        checkedIcon: /*#__PURE__*/React.createElement(RadioButtonCheckedIcon, {
          className: classes.icon
        }),
        icon: /*#__PURE__*/React.createElement(RadioButtonUncheckedIcon, {
          className: classes.icon
        })
      }),
      label: value,
      disabled: disabled
    }));
  }))));
}

export { RadioButtons };